export const PRICE_DROP_SUPPRESSION_EXPERIMENT =
  'car-merch-ui-price-drop-merchandising-suppression';
